/* eslint-disable react/jsx-props-no-spreading */
// @flow

import React, { type ElementConfig } from 'react';
import RSelect, { components } from 'react-select';
import cx from 'classnames';
import { P } from 'components';
import './styles.scss';

export type Value = string | number;

export type SelectOption = {
  label: string,
  value: Value,
};

type Props = {
  options: SelectOption[],
  onChange: (option: SelectOption) => void,
  disabled?: boolean,
  value?: Value,
  error?: string,
  placeholder?: string,
  label?: string,
  name?: string,
  className?: string,
  style?: string,
  size?: 'sm' | 'md',
  isSearchable?: boolean
}

const DropdownIndicator = (props: ElementConfig<typeof components.DropdownIndicator>) => (
  <components.DropdownIndicator {...props}>
    <span className="rs__dropdown-indicator" />
  </components.DropdownIndicator>
);

const Select = ({
  options,
  onChange,
  disabled,
  value,
  placeholder,
  label,
  error = '',
  name = '',
  className,
  style,
  size = 'md',
  isSearchable = false,
  ...rest
}: Props) => (
  <div
    style={style}
    className={cx(
      className,
      { 'rs__select-error': !!error },
      { 'rs__select-disabled': !!disabled },
      size,
    )}
  >
    { label && <span className="rs__label">{label}</span> }
    <RSelect
      {...rest}
      options={options}
      value={value}
      className="rs__select"
      classNamePrefix="rs"
      components={{ DropdownIndicator }}
      onChange={onChange}
      isDisabled={disabled}
      placeholder={placeholder}
      name={name}
      isSearchable={isSearchable}
    />
    {error && <P use="error">{error}</P>}
  </div>
);

export default Select;
